import { useState } from "react";
import { Plus } from "lucide-react";
import { inr, useCan, useLoad } from "@/lib/api";
import { ErrorBox, PageHeading } from "@/components/common";
import TreatmentForm from "@/components/forms/TreatmentForm";
import { TreatmentList } from "@/components/ledgerLists";

export default function TreatmentLedger() {
  const can = useCan();
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState("all");
  const { data, error, reload } = useLoad("/treatments", []);
  const rows = status === "all" ? data : data.filter((t) => t.status === status);
  const agreed = data.filter((t) => t.status !== "cancelled").reduce((s, t) => s + t.agreed_amount, 0);
  return (
    <div className="content">
      <PageHeading eyebrow="TREATMENT LEDGER" title="Agreed care," accent="clearly priced." sub="Cancelled treatments are excluded from what patients owe.">
        {can("treatments:write") && <button className="primary" onClick={() => setShow(true)} data-testid="add-treatment-button"><Plus size={18} /> Add treatment</button>}
      </PageHeading>
      <div className="toolbar">
        <div className="chips">{["all", "planned", "in_progress", "completed", "cancelled"].map((s) => <button key={s} className={status === s ? "chip active" : "chip"} onClick={() => setStatus(s)} data-testid={`treatment-filter-${s}`}>{s.replace("_", " ")}</button>)}</div>
        <span className="result-count" data-testid="treatment-agreed-total">Agreed total {inr(agreed)}</span>
      </div>
      <ErrorBox error={error} testid="treatments-error" />
      <TreatmentList rows={rows} onChanged={reload} />
      {show && <TreatmentForm onClose={() => setShow(false)} onSaved={() => { setShow(false); reload(); }} />}
    </div>
  );
}
